module.exports = __webpack_public_path__ + "static/category-hoodie-dad86b27abb0eaecdd4a3288727b46de.jpg";